import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { SizeService } from '../../../services/size-detection/size.service';
import { StringTransformationService } from 'src/app/services/transformation-helper/string-transformation.service';

@Component({
  selector: '[sb-pagination]',
  templateUrl: './sb-pagination.component.html',
  styleUrls: ['./sb-pagination.component.scss'],
  standalone: false,
})
export class SbPaginationComponent implements OnInit {
  readonly stringTransformation = inject(StringTransformationService);
  debounceTimer: ReturnType<typeof setTimeout> = null;
  protected readonly Math = Math;

  @Input() maxSize: number = 8;
  @Input() collectionSize: number;
  @Input() page: number;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() pageSizeChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() boundaryLinks: boolean = true;
  @Input() showPageSize: boolean = true;
  @Input() showPageCount: boolean = true;
  @Input() showGotoPage: boolean = true;
  dropdownOpen: boolean;
  goto: number;
  displayedPages: number = 5;

  constructor(public sizeService: SizeService) {}

  _sizes: number[] = [8, 12, 16, 20, 24, 50, 100];

  get sizes(): number[] {
    return this._sizes;
  }

  @Input() set sizes(val: number[]) {
    if (val) {
      this._sizes = val;
    } else {
      this._sizes = [8, 12, 16, 20, 24, 50, 100];
    }
  }

  ngOnInit(): void {
    this.sizeService.onResize$().subscribe(() => {
      if (this.sizeService.checkScreensize(['sm', 'xs'])) {
        this.displayedPages = 3;
      } else {
        this.displayedPages = 5;
      }
    });
  }

  gotoDebounced($event) {
    this.goto = $event;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.goToPage();
    }, 500);
  }

  goToPage() {
    const max = Math.ceil(this.collectionSize / this.maxSize);
    if (this.goto <= 0 || isNaN(this.goto)) {
      this.goto = 1;
    } else if (this.goto > max) {
      this.goto = max;
    }
    this.onPageChange(this.goto);
  }

  onPageChange($event) {
    this.page = $event;
    this.pageChange.emit($event);
    this.goto = $event;
  }

  setPageSize($event) {
    this.maxSize = $event;
    this.pageSizeChange.emit($event);
  }
}
